import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var AuthenticationErrorCode;

(function (AuthenticationErrorCode) {
  // The user is not currently signed in
  AuthenticationErrorCode[AuthenticationErrorCode["NotSignedIn"] = 1000] = "NotSignedIn"; // The user cancelled the auth request

  AuthenticationErrorCode[AuthenticationErrorCode["UserCancelled"] = 1001] = "UserCancelled"; // Either you did not request offline access, or the user did not approve your app for offline access

  AuthenticationErrorCode[AuthenticationErrorCode["NoRefreshToken"] = 1002] = "NoRefreshToken"; // You requested silent sign in, which is deprecated

  AuthenticationErrorCode[AuthenticationErrorCode["UnsupportedAuthenticationMethod"] = 1003] = "UnsupportedAuthenticationMethod"; // We received an error from the oauth server

  AuthenticationErrorCode[AuthenticationErrorCode["ServerError"] = 1004] = "ServerError"; // The SDK is configured incorrectly

  AuthenticationErrorCode[AuthenticationErrorCode["InvalidConfiguration"] = 1005] = "InvalidConfiguration"; // Popup blocked

  AuthenticationErrorCode[AuthenticationErrorCode["PopupBlocked"] = 1006] = "PopupBlocked";
})(AuthenticationErrorCode || (AuthenticationErrorCode = {}));
/**
 * Represents an error that is thrown during the authentication process
 */


export var AuthenticationError = /*#__PURE__*/function (_Error) {
  _inherits(AuthenticationError, _Error);

  var _super = _createSuper(AuthenticationError);

  function AuthenticationError(message, code) {
    var _this;

    _classCallCheck(this, AuthenticationError);

    _this = _super.call(this, message);
    _this.name = 'AuthenticationError'; // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), AuthenticationError);
    }

    _this.code = code;
    return _this;
  } // throw AuthenticationError.NotSignedIn()


  _createClass(AuthenticationError, null, [{
    key: "NotSignedIn",
    value: function NotSignedIn() {
      return new AuthenticationError('Not signed in.', AuthenticationErrorCode.NotSignedIn);
    } // throw AuthenticationError.UserCancelled()

  }, {
    key: "UserCancelled",
    value: function UserCancelled() {
      return new AuthenticationError('Sign in request was cancelled.', AuthenticationErrorCode.UserCancelled);
    } // throw AuthenticationError.NoRefreshToken()

  }, {
    key: "NoRefreshToken",
    value: function NoRefreshToken() {
      return new AuthenticationError('Refresh token is not available.', AuthenticationErrorCode.NoRefreshToken);
    } // throw AuthenticationError.UnsupportedAuthenticationMethod()

  }, {
    key: "UnsupportedAuthenticationMethod",
    value: function UnsupportedAuthenticationMethod() {
      return new AuthenticationError('Sign in method not supported.', AuthenticationErrorCode.UnsupportedAuthenticationMethod);
    } // throw AuthenticationError.PopupBlocked()

  }, {
    key: "PopupBlocked",
    value: function PopupBlocked(baseUrl) {
      var msg = "The popup was blocked. Please make sure ".concat(baseUrl, " is allowed to open popups.");
      return new AuthenticationError(msg, AuthenticationErrorCode.PopupBlocked);
    } // throw Authentication Error.ServerError(message, description)

  }, {
    key: "ServerError",
    value: function ServerError(message, description) {
      var err = new AuthenticationError("Error from the server: ".concat(message), AuthenticationErrorCode.ServerError);
      err.description = description;
      return err;
    } // throw AuthenticationError.InvalidConfiguration()

  }, {
    key: "InvalidConfiguration",
    value: function InvalidConfiguration(reason) {
      return new AuthenticationError("The OAuth Configuration is invalid: ".concat(reason), AuthenticationErrorCode.InvalidConfiguration);
    }
  }]);

  return AuthenticationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));